const GENERIC_ERROR = 'Não foi possível enviar a mensagem. Tente novamente mais tarde.';

export function sanitizeApiMessage(message) {
  if (typeof message !== 'string') {
    return GENERIC_ERROR;
  }

  const cleaned = message
    .replace(/<[^>]*>/g, '')
    .replace(/javascript:/gi, '')
    .replace(/data:text\/html/gi, '')
    .trim();

  if (!cleaned) {
    return GENERIC_ERROR;
  }

  return cleaned.slice(0, 400);
}
